import { createBackendAPI } from '../../../utils/client/backendApi';
import { API_PATHS, SCORE_SUMMARY_SERVICE_NAME } from '../constants';
import { IScoreSummaryResponse } from '../types/api';

const STATUS_SUCESSO = '1';

export async function getScoreSummary(document: string): Promise<IScoreSummaryResponse> {
  const api = createBackendAPI('fintech');

  const {data} = await api.post(
    API_PATHS.SCORE_SUMMARY_SERVICE_PATH,
    { requestBody: { documento: document } },
    { params: { serviceName: SCORE_SUMMARY_SERVICE_NAME, outputType: 'json' } },
  );

  if (!isSuccessResponse(data)) {
    throw new Error('Envelope inesperado em ScoreSP.getSummary');
  }

  return data.responseBody as IScoreSummaryResponse;
}

function isSuccessResponse(data: any) : boolean {
  return STATUS_SUCESSO === data.status;
}
